import React, { useState } from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import "./ShopDataGrid.css";
import { useNavigate } from "react-router-dom";
import { Grid, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { DeleteModal } from "./DeleteModal";
import { Category } from "../model/Category";
import { deleteCategory } from "../service/CategoryService";

export function CategoryDataGrid({
  categories,
  setDeleteCategory,
}: {
  categories: Category[];
  setDeleteCategory: (deleteCategory: boolean) => void;
}) {
  const navigate = useNavigate();
  const rows = categories.map((category) => ({
    id: category.uid,
    ...category,
  }));

  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(
    null,
  );
  const handleOpen = (category: Category) => {
    setSelectedCategory(category);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCategory(null);
  };

  const handleDelete = async () => {
    if (selectedCategory) {
      await deleteCategory(selectedCategory.uid, selectedCategory.imageUrl);
      handleClose();
      setDeleteCategory(true);
    }
  };
  const columns: GridColDef[] = [
    { field: "uid", headerName: "ID", flex: 1 },
    {
      field: "name",
      headerName: "Nom",
      flex: 1,
    },
    {
      field: "imageUrl",
      headerName: "",
      flex: 1,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <img
            src={params.value || ""}
            alt={params.row.name}
            style={{ width: "100px", height: "100px" }}
          />
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <IconButton
          color="error"
          onClick={(event) => {
            event.stopPropagation();
            handleOpen(params.row);
          }}
          aria-label="delete"
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];
  const handleRowClick = (param: any) => {
    navigate(`/category/edit/${param.id}`);
  };

  return (
    <>
      <Grid style={{ height: "calc(100vh - 64px)", width: "100%" }}>
        <DataGrid
          rows={rows}
          rowHeight={100}
          columns={columns}
          pageSizeOptions={[5, 10, 20]}
          disableRowSelectionOnClick
          initialState={{
            pagination: { paginationModel: { pageSize: 20 } },
          }}
          sx={{
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "primary.main",
            },
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
          }}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
          }
          onRowClick={handleRowClick}
        />
      </Grid>
      <DeleteModal
        open={open}
        onClose={handleClose}
        onDelete={handleDelete}
        title={
          <>
            Voulez-vous vraiment supprimer{" "}
            <strong>{selectedCategory?.name}</strong> ?
          </>
        }
      />
    </>
  );
}
